import * as React from 'react';
import { dividedChildren } from './dividedChildren';

interface WorkbenchSectionProps {
  title: string;
  /** The change workbench titled itself with an h2; the other two used MUI's default h6. */
  titleAs?: 'h2' | 'h6';
  description: React.ReactNode;
  emptyMessage: string;
  isEmpty: boolean;
  children?: React.ReactNode;
}

const WorkbenchSection: React.FC<WorkbenchSectionProps> = ({
  title,
  titleAs: Heading = 'h6',
  description,
  emptyMessage,
  isEmpty,
  children,
}) => (
  <div className="flex flex-col gap-5">
    <div>
      <Heading className="revy-cjk text-base font-medium leading-[1.6]">{title}</Heading>
      <p className="revy-cjk revy-figure text-sm leading-[1.6] text-muted-foreground">
        {description}
      </p>
    </div>

    {isEmpty ? (
      <p className="revy-cjk text-base leading-[1.6] text-muted-foreground">{emptyMessage}</p>
    ) : (
      <div className="flex flex-col gap-5">{dividedChildren(children)}</div>
    )}
  </div>
);

export { WorkbenchSection };
